export const APP_VARIABLES = {
    // LocalStorage item names
    currentUser: 'SCAN.CURRENT_USER',
    lastSeenPage: 'SCAN.LASTSEENPAGE',
    impersonatedUser: 'impersonatedUser',
};
